import banner1 from './banner1.png'
import banner2 from './banner2.png'
import banner3 from './banner3.png'
import banner4 from './banner4.png'
import banner5 from './banner5.png'
import banner6 from './banner6.png'
import banner7 from './banner7.png'
import banner8 from './banner8.png'
import newsLogo0 from './news-logo-0.png'
import newsLogo1 from './news-logo-1.png'
import newsLogo2 from './news-logo-2.png'
import newsLogo3 from './news-logo-3.png'
import newsLogo4 from './news-logo-4.png'
import newsLogo5 from './news-logo-5.png'
import newsLogo6 from './news-logo-6.png'
import newsLogo7 from './news-logo-7.png'
import newsLogo8 from './news-logo-8.png'
import newsLogo9 from './news-logo-9.png'
import newsLogo10 from './news-logo-10.png'
import newsLogo11 from './news-logo-11.png'
import news1 from './news1.jpg'
import news2 from './news2.jpg'
import news3 from './news3.jpg'
import news4 from './news4.jpg'
import news5 from './news5.jpg'
import news6 from './news6.jpg'
import news7 from './news7.jpg'
import news8 from './news8.jpg'
import news9 from './news9.jpg'
import news10 from './news10.jpg'
import news11 from './news11.jpg'
import news12 from './news12.jpg'
import news13 from './news13.jpg'
import news14 from './news14.jpg'
import newsImage from './news-image.png'
import newImg1 from './new-img1.png'
import newImg2 from './new-img2.png'
import newImg3 from './new-img3.png'
import instagram from './instagram.png'
import facebook from './facebook.png'
import twitter from './twitter.png'
import normal from './normal.png'
import noimal from './noimal.png'
import hover from './hover.png'
import close from './close.png'
let newsLogo = [
  {
    picUrl:newsLogo0,
    linkUrl:'https://abema.tv/'
  },
  {
    picUrl:newsLogo1,
    linkUrl:'https://tver.jp/'
  },
  {
    picUrl:newsLogo2,
    linkUrl:'https://gyao.yahoo.co.jp/'
  },
  {
    picUrl:newsLogo3,
    linkUrl:'https://www.dplay.jp/'
  },
  {
    picUrl:newsLogo4,
    linkUrl:'https://www.netflix.com/jp/'
  },
  {
    picUrl:newsLogo5,
    linkUrl:'https://fod.fujitv.co.jp/s/'
  },
  {
    picUrl:newsLogo6,
    linkUrl:'https://www.amazon.co.jp/gp/video/getstarted'
  },
  {
    picUrl:newsLogo7,
    linkUrl:'https://www.hulu.jp/'
  },
  {
    picUrl:newsLogo8,
    linkUrl:'https://video.unext.jp/'
  },
  {
    picUrl:newsLogo9,
    linkUrl:'https://www.dazn.com/ja-JP/home'
  },
  {
    picUrl:newsLogo10,
    linkUrl:'https://navi.telasa.jp/'
  },
  {
    picUrl:newsLogo11,
    linkUrl:'https://www.b-ch.com/'
  }
]
let banner = {
  autoDisplayFlag: true,
  data: [
    {
      picUrl: banner1,
    },
    {
      picUrl: banner8,
    },
    {
      picUrl: banner2,
    },
    {
      picUrl: banner3,
    },
    {
      picUrl: banner4,
    },
    // {
    //   picUrl: banner5,
    // },
    {
      picUrl: banner6,
    },
    {
      picUrl: banner7,
    }
  ]
}
banner.data.forEach(n => {
  n['linkUrl'] = null
})
banner.data[5].linkUrl = '/buy'
export {
  banner as banner,
  newsLogo as newsLogo,
  newsImage as newsImage,
  newImg1 as newImg1,
  newImg2 as newImg2,
  newImg3 as newImg3,
  instagram as instagram,
  facebook as facebook,
  twitter as twitter,
  news1 as news1,
  news2 as news2,
  news3 as news3,
  news4 as news4,
  news5 as news5,
  news6 as news6,
  news7 as news7,
  news8 as news8,
  news9 as news9,
  news10 as news10,
  news11 as news11,
  news12 as news12,
  news13 as news13,
  news14 as news14,
  normal as normal,
  noimal as noimal,
  hover as hover,
  close as close,
}


// WEBPACK FOOTER //
// ./src/images/news/index.js